export const BaseUrl='https://connect.ram.bookseva.com/api'
// export const BaseUrl='http://localhost:5055/api'


export const appVersion = '1.0.4'; 
 